import React from 'react';

import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { ChartWrapper } from './OriginalBudgetLeftChart.styles';
import { colors } from '@alixpartners/ui-components';

export const OriginalBudgetLeftChart = ({ spendFormatter, series, title }) => {
	const chartOptions = {
		chart: {
			type: 'columnrange',
			marginTop: 41,
			width: 275,
			height: 310,
			style: { fontFamily: 'Roboto' },
			spacingBottom: 40,
			events: {
				redraw: e => {
					transformSelection(e.target);
				},
			},
		},
		title: {
			text: '',
		},
		exporting: { enabled: false },
		credits: {
			enabled: false,
		},
		xAxis: {
			type: 'category',
			title: {
				enabled: false,
			},
			lineColor: 'black',
			labels: {
				autoRotation: false,
				style: {
					fontSize: '11px',
					fontWeight: '400',
					lineHeight: '13px',
					letterSpacing: 0,
					color: colors.grey8,
				},
			},
			gridLineWidth: 0,
			plotBands: [
				{
					from: 0.5,
					to: 1.5,
					color: colors.greyBg,
					label: {
						useHTML: true,
						text: '',
						verticalAlign: 'bottom',
						y: 50,
					},
				},
			],
		},
		yAxis: {
			title: {
				align: 'high',
				text: title,
				textAlign: 'right',
				rotation: 0,
				y: -30,
				offset: 15,
				style: {
					fontSize: '11px',
					fontWeight: '400',
					lineHeight: '13px',
					letterSpacing: 0,
					color: colors.grey8,
				},
			},
			gridLineWidth: 0,
			lineColor: 'black',
			lineWidth: 1,
			labels: {
				style: {
					fontSize: '11px',
					fontWeight: '400',
					lineHeight: '13px',
					letterSpacing: 0,
					color: colors.grey8,
				},
				formatter: function() {
					return spendFormatter(this.value, true);
				},
			},
		},
		legend: {
			enabled: false,
		},
		tooltip: {
			enabled: false,
		},
		plotOptions: {
			columnrange: {
				dataLabels: {
					enabled: true,
					style: {
						fontWeight: '500',
					},
					crop: false,
					overflow: 'allow',
					formatter: function(e) {
						if (e.verticalAlign === 'bottom') {
							const { low, high } = this.point;

							return spendFormatter(high - low, true);
						}
					},
				},
			},
			series: {
				animation: false,
				borderWidth: 0,
				pointPadding: 0,
				pointWidth: 48,
				states: {
					hover: {
						enabled: false,
					},
				},
			},
		},
		series,
	};

	const transformSelection = chart => {
		if (
			chart &&
			chart.xAxis &&
			chart.xAxis[0] &&
			chart.xAxis[0].plotLinesAndBands
		) {
			chart.xAxis[0].plotLinesAndBands.forEach(plotBand => {
				plotBand.svgElem.attr({
					transform: 'translate(0, -66) scale(1, 1.6)',
				});
			});
		}
	};
	const onChartInit = chart => {
		transformSelection(chart);
	};

	return (
		<ChartWrapper>
			<HighchartsReact
				highcharts={Highcharts}
				options={chartOptions}
				callback={onChartInit}
			/>
		</ChartWrapper>
	);
};

export default OriginalBudgetLeftChart;
